import { Promise } from 'es6-promise'
import commonRequest from 'Api/index'

// state
const state = {
    suppliers: []
}

// getters
const getters = {
    SUPPLIER_BY_VOUCHER_OF_CUSTOMER_DATA: state => {
        return state.suppliers
    }
}

// actions
const actions = {
    GET_SUPPLIER_BY_VOUCHER_OF_CUSTOMER: (context, payload) => {
        return new Promise((resolve, reject) => {
            commonRequest.getRequest(
                process.env.VUE_APP_BACKEND_CORE_URL,
                'api/v1/0/entity/get_supplier_by_voucher_of_customer/',
                payload,
                function (res) {
                    context.commit('GET_SUPPLIER_BY_VOUCHER_OF_CUSTOMER_HANDLER', res.data)
                    resolve(res)
                },
                function (error) {
                    reject(error)
                }
            )
        })
    },
}

// mutations
const mutations = {
    GET_SUPPLIER_BY_VOUCHER_OF_CUSTOMER_HANDLER(state, payload) {
        state.suppliers = payload
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}